import { render, staticRenderFns } from "./ChannelSettingModal.vue?vue&type=template&id=58f4b57a&scoped=true&"
import script from "./ChannelSettingModal.vue?vue&type=script&lang=js&"
export * from "./ChannelSettingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f4b57a",
  null
  
)

export default component.exports